import { Spin } from 'antd';
import { isArray, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import { Arrow_Down_2, Arrow_Up_2, avatar, homepage_icon } from '../../../assets/img';
import { BreadCrumb, ModelTC } from '../../../components';
import GlobalAlertMessage from '../../../components/GlobalAlertMessage/GlobalAlertMessage';
import { useShowPopupSaveAgenda } from '../../../hooks/useShowPopupSaveAgenda';
import { useUpdatePdcMobilityStepNumber } from '../../../hooks/useUpdatePdcMobilityStepNumber';
import { pdcMeetingApi } from '../../../services/pdcMeetingApi';
import {
  CONTRACT_TALENTS_SALARY_GRADE,
  NOTIFICATION_TYPE,
  PDC_PROPOSAL_TYPES,
  PROPOSAL_LABEL,
  PROPOSAL_SELECT_OPTIONS,
  PROPOSAL_TYPES,
  SELECT_ALL_LABEL,
  USER_ACCESS_MESSAGE,
} from '../../../utils/constants';
import { showNotification } from '../../../utils/notification';
import MobilityBotButtonControls from '../components/MobilityButtonControls/MobilityBotButtonControls';
import MobilityTopButtonControls from '../components/MobilityButtonControls/MobilityTopButtonControls';
import MobilityFinalizeBar from '../components/MobilityFinalizeBar/MobilityFinalizeBar';
import PdcMobilityProcessBar from '../components/PdcMobilityProcessBar/PdcMobilityProcessBar';
import * as styles from './pdc-proposal-talent-list.module.scss';
import ProposalSetting from '../../../components/ProposalSetting/ProposalSetting';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import PdcProposalDetail from '../PdcProposalList/components/PdcProposalItem/PdcProposalDetail';
import { READINESS_VALUE } from '../constants';
import { TextAreaWithCounter } from '../../../components/TextAreaWithCounter/TextAreaWithCounter';
import usePDCMeetingMobilityAgendaUrl from '../../../hooks/usePDCMeetingMobilityAgendaUrl';

const CustomBtn = styled.button`
  border: none;
  background: transparent;
  padding: 5px 7px;

  img {
    width: 24px;
    height: 24px;
  }
`;

const PdcProposalTalentList = (props) => {
  const history = useHistory();
  const { idMeeting, mobilityId, proposalId } = useParams();
  const userInfos = useSelector((state) => state.user);
  const { roleId } = useSelector((state) => state.user.roleActive);
  const [itemExpand, setItemExpand] = useState(null);
  const [talentItemList, setTalentItemList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [initProposalOptions, setInitProposalOptions] = useState([]);
  const [proposalType, setProposalType] = useState(null);
  const [proposalTypeName, setProposalTypeName] = useState('');
  const [isOpenSettingHasType, setIsOpenSettingHasType] = useState(false);
  const [currentOpenSettingProposal, setCurrentOpenSettingProposal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [proposallTalentList, setProposalTalentList] = useState([]);
  const [isTemplateContentOpen, setIsTemplateContentOpen] = useState(false);
  const [openStaffId, setOpenStaffId] = useState(null);
  const [proposalList, setProposalList] = useState({
    positions: [],
    talents: [],
  });
  const [isBack, setIsBack] = useState(false);
  const [compareData, setCompareData] = useState({
    initData: [],
    currentData: [],
  });

  const mobilityAgendaUrl = usePDCMeetingMobilityAgendaUrl(idMeeting);
  const BREAD_CRUMB = [
    { name: 'Homepage', icon: homepage_icon, url: '/homepage' },
    { name: 'PDC Meeting', url: '/pdc' },
    { name: 'Mobility Agenda', url: mobilityAgendaUrl },
    { name: 'Proposal' },
  ];

  // Get the condition to edit mobility agenda
  const {
    isOnlyViewAgenda,
    isShowTopButtons,
    isShowBotButtons,
    isAdditionalViewAccess,
    meetingDetail,
    mobilityDetails,
    isEnableMobilityTab,
    proposalMainStep,
    fetchMobilityDetails,
    isShownMobilityTabBar,
    isHRPartners,
    isChairMainOrCommiteeOrAdvocator,
  } = props;
  const { updateStepNumber } = useUpdatePdcMobilityStepNumber();

  // Update current data to compare value
  useEffect(() => {
    setCompareData((prev) => ({
      ...prev,
      currentData: proposalList,
    }));
  }, [proposalList]);

  const isChangeProposalList = useMemo(() => {
    return JSON.stringify(compareData.initData) !== JSON.stringify(compareData.currentData);
  }, [compareData]);

  const { isShowPopupSaveAgenda, handleKeepNavigate, setIsShowPopupSaveAgenda } = useShowPopupSaveAgenda(isChangeProposalList && !isBack);

  const fetchMobility = useCallback(async () => {
    if (!mobilityId) return;
    try {
      setLoading(true);
      const res = await pdcMeetingApi.getProposalMultipleTalentOrPosition(mobilityId, PDC_PROPOSAL_TYPES.MULTIPLE_TALENT);
      if (res.status === 200) {
        setProposalList(res?.data?.result);
        let talents = [];

        if (!isEmpty(res?.data?.result?.talents) && Array.isArray(res?.data?.result?.talents)) {
          talents = res?.data?.result?.talents;
        }

        setProposalTalentList(talents);
        setCompareData((prev) => ({
          ...prev,
          initData: talents,
          currentData: talents,
        }));
      }
    } catch (error) {
      // console.error(error);
      showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
    } finally {
      setLoading(false);
    }
  }, [mobilityId]);

  // Fetch mobility in the first time
  useEffect(() => {
    fetchMobility();
  }, [fetchMobility]);

  const handleClickBack = async () => {
    history.push(`/pdc-meeting/${idMeeting}/mobility/${mobilityId}`);
  };

  const handleSaveBeforeExit = async () => {
    setIsBack(true);
    setIsShowPopupSaveAgenda(false);
    await handleSaveAsDraft();
    handleKeepNavigate();
  };

  const handleClickNext = async () => {
    if (proposalMainStep?.step < 2) {
      await updateStepNumber(mobilityId, 2);
    }
    history.push(`/pdc-meeting/${idMeeting}/mobility/${mobilityId}/assessment/${proposalId}?mobilityType=talents`);
  };

  const handleSaveAsDraft = async () => {
    if (!roleId) return;

    try {
      setLoading(true);
      const payload = !isEmpty(proposallTalentList)
        ? proposallTalentList.map((item, index) => {
            const tempSuccessor = item?.proposal_settings?.positionInfo?.identifiedSuccessors?.successorList;
            const tempReplacement = item?.proposal_settings?.staffInfo?.replacement?.replacement_staff_ids;
            const tempFirstLineSuccessor = item?.proposal_settings?.staffInfo?.successor_to_1st_line;
            const tempSecondLineSuccessor = item?.proposal_settings?.staffInfo?.successor_to_2nd_line;
            const tempThirdLineSuccessor = item?.proposal_settings?.staffInfo?.successor_to_3rd_line;
            return {
              order: index + 1,
              staff_id: item?.staff_id,
              mobility_id: item?.mobility_id,
              mobility_proposal_id: proposalId,
              position_code: item?.position_code,
              proposal_type: item?.proposal_type,
              proposal_type_name: item?.proposal_type_name?.trim(),
              replacement_staff_lists: !isEmpty(tempReplacement) ? tempReplacement.map((i) => i.staffId || i.staff_id) : [],
              replacement_save_status: item?.proposal_settings?.staffInfo?.replacement?.save,
              replacement_input_value: item?.proposal_settings?.staffInfo?.replacement?.replacement_input_value,
              previous_contract_details: item?.proposal_settings?.staffInfo?.previous_contract_details,
              previous_secondment: item?.proposal_settings?.staffInfo?.previous_secondment,
              identified_successor_staff_lists: !isEmpty(tempSuccessor) ? tempSuccessor.map((s) => s.staffId || s.staff_id) : [],
              successor_first_line_position_code_lists: !isEmpty(tempFirstLineSuccessor)
                ? tempFirstLineSuccessor.map((s) => s.position_code || s.position_code)
                : [],
              successor_second_line_position_code_lists: !isEmpty(tempSecondLineSuccessor)
                ? tempSecondLineSuccessor.map((s) => s.position_code || s.position_code)
                : [],
              successor_third_line_position_code_lists: !isEmpty(tempThirdLineSuccessor)
                ? tempThirdLineSuccessor.map((s) => s.position_code || s.position_code)
                : [],
              identified_successor_save_status: item?.proposal_settings?.positionInfo?.identifiedSuccessors?.save,
              identified_successor_input_value: item?.proposal_settings?.positionInfo?.identifiedSuccessors?.identified_successor_input_value,
              justification: item?.proposal_settings?.justificationInfo?.justification,
              decision_remarks: item?.proposal_settings?.decisionInfo?.decision_remarks,
              effective_start_date: item?.proposal_settings?.decisionInfo?.effectiveStartDate,
              effective_end_date: item?.proposal_settings?.decisionInfo?.effectiveEndDate,
              contract_start_date: item?.proposal_settings?.decisionInfo?.contractStartDate,
              contract_end_date: item?.proposal_settings?.decisionInfo?.contractEndDate,
              decision: item?.proposal_settings?.decisionInfo?.decision?.selectedDecision,
              remarks: item?.proposal_settings?.decisionInfo?.remarks,
              proposal_compare_successors: item?.proposal_compare_successors,
              proposal_settings: !isEmpty(item?.proposal_item_list) ? handleReturnProposalItemList(item?.proposal_item_list) : [],
              note: item?.proposal_settings?.staffInfo?.note,
              current_incumbent_input_value: item?.proposal_settings?.positionInfo?.current_incumbent_input_value,
              current_incumbent_toggle: item?.proposal_settings?.positionInfo?.current_incumbent_toggle ? 1 : 0,
            };
          })
        : [];
      const res = await pdcMeetingApi.updateMultipleProposalList(payload, proposalList.positions.at(0)?.position_code, roleId, userInfos);
      if (res.status === 200) {
        if (proposalMainStep?.step < 2) {
          await updateStepNumber(mobilityId, 2);
        }
        setCompareData((prev) => ({
          ...prev,
          initData: prev.currentData,
        }));
        return true;
      }
    } catch (error) {
      console.error(error);
      showNotification(USER_ACCESS_MESSAGE.AN_UNEXPECTED_ERROR, NOTIFICATION_TYPE.FAILED);
    } finally {
      setLoading(false);
    }
  };

  const handleReturnExpandCollapseClass = (itemExpand, currentItem) => {
    return itemExpand?.staff_id === currentItem?.staff_id ? styles.expanded : styles.collapsed;
  };

  const getProposalPrevValue = (record) => {
    let tempData;
    if (!isEmpty(compareData.initData)) {
      compareData.initData.forEach((i) => {
        if (i?.staff_id === record?.staff_id) {
          tempData = i;
        }
      });
    }
    return tempData;
  };

  // Fetch proposal item list
  const flattenProposalItems = (data) => {
    const result = [];
    const traverse = (items) => {
      items?.forEach((item) => {
        result.push({
          label: item.label,
          value: item.value,
          checked: item.checked,
        });

        if (Array.isArray(item.children)) {
          traverse(item.children);
        }
      });
    };
    traverse(data);
    return result;
  };

  const handleExpandCollapseItem = async (record) => {
    handleSaveAsDraft();

    setItemExpand(record);

    if (!record?.proposal_type) {
      setTalentItemList([]);
      setProposalType(null);
      setProposalTypeName('');
      setIsTemplateContentOpen(false);
      setOpenStaffId(null);
      return;
    }

    const isCheck = !isEmpty(record?.proposal_item_list) ? isEmpty(record?.proposal_item_list[0]?.children) : false;
    const tempSettings = isCheck ? record?.proposal_item_list : flattenProposalItems(record?.proposal_item_list)?.filter((i) => i.checked);

    setTalentItemList(tempSettings);
    setProposalType(record?.proposal_type);
    setProposalTypeName(record?.proposal_type_name);

    await fetchTemplateContent(record, tempSettings, true);
    setOpenStaffId(record?.staff_id);
    setIsTemplateContentOpen(true);
  };

  const handleReturnProposalItemList = (dataList) => {
    const isValid = !isEmpty(dataList) ? isEmpty(dataList[0]?.children) : false;

    const markChecked = (item) => ({
      ...item,
      checked: !!dataList.find((f) => f.value === item.value),
    });

    const processChildren = (items = []) =>
      items.map((item) => {
        const updatedItem = markChecked(item);
        if (!isEmpty(item.children)) {
          return {
            ...updatedItem,
            children: processChildren(item.children),
          };
        }
        return updatedItem;
      });

    return isValid ? processChildren(PROPOSAL_SELECT_OPTIONS.slice(1)) : dataList;
  };

  // Fetch template content
  const fetchTemplateContent = async (iExpandItem, settings, isApplied) => {
    if (isEmpty(settings) || !iExpandItem || !isApplied) {
      return;
    }

    setIsTemplateContentOpen(true);
    setOpenStaffId(iExpandItem?.staff_id);

    const positionCode = proposalList.positions?.[0]?.position_code;

    try {
      setLoading(true);
      const res = await pdcMeetingApi.getTemplateContent({
        staff_id: iExpandItem?.staff_id,
        position_code: positionCode,
        mobility_id: iExpandItem?.mobility_id,
        mobility_proposal_id: proposalId,
        data: handleReturnProposalItemList(settings),
        roleId,
        proposal_type: iExpandItem?.proposal_type,
      });

      if (res.status === 200) {
        setProposalTalentList((prev) => {
          return !isEmpty(prev)
            ? prev.map((item) => {
                if (item?.staff_id === iExpandItem?.staff_id) {
                  // Merge new settings with existing user input
                  // Preserve proposal_item_list: use settings parameter (which is the proposal_item_list array)
                  // or fallback to existing item.proposal_item_list if settings is not provided
                  const preservedProposalItemList = Array.isArray(settings) ? settings : item?.proposal_item_list || [];

                  return {
                    ...item,
                    proposal_settings: mergeProposalSettings(item?.proposal_settings, res?.data?.result),
                    proposal_item_list: preservedProposalItemList, // Preserve proposal_item_list for isProposalItemSelected checks
                  };
                }
                return item;
              })
            : [];
        });

        setCompareData((prev) => ({
          ...prev,
          initData: isArray(prev?.initData)
            ? prev.initData.map((i) => {
                if (i?.staff_id === iExpandItem?.staff_id) {
                  // Merge new settings with existing user input
                  // Preserve proposal_item_list: use settings parameter (which is the proposal_item_list array)
                  // or fallback to existing i.proposal_item_list if settings is not provided
                  const preservedProposalItemList = Array.isArray(settings) ? settings : i?.proposal_item_list || [];
                  return {
                    ...i,
                    proposal_settings: mergeProposalSettings(i?.proposal_settings, res?.data?.result),
                    proposal_item_list: preservedProposalItemList, // Preserve proposal_item_list for isProposalItemSelected checks
                  };
                }
                return i;
              })
            : [],
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSettingProposal = (record) => {
    setCurrentOpenSettingProposal(record);

    if (!record?.proposal_type) {
      setTalentItemList([]);
      setProposalType(null);
      setProposalTypeName('');
      return;
    }

    const isCheck = !isEmpty(record?.proposal_item_list) ? isEmpty(record?.proposal_item_list[0]?.children) : false;
    setIsOpenSettingHasType(true);
    setTalentItemList(isCheck ? record?.proposal_item_list : flattenProposalItems(record?.proposal_item_list)?.filter((i) => i.checked));
    setProposalType(record?.proposal_type);
    setProposalTypeName(record?.proposal_type_name);
  };

  // Helper function to merge proposal settings while preserving user input
  const mergeProposalSettings = (existingSettings, newSettings) => {
    if (!newSettings) return newSettings;
    // If no existing settings, just return the new settings (first time setting proposal type)
    if (!existingSettings) return newSettings;

    // Merge a section by only preserving values for keys that exist in newSection
    const mergeSection = (existingSection, newSection) => {
      if (!newSection || typeof newSection !== 'object') return newSection;

      const merged = { ...newSection };

      // Preserve existing values only for keys present in the new section
      Object.keys(newSection).forEach((key) => {
        const existingValue = existingSection?.[key];
        // Preserve if existing value is truthy, or if it's explicitly false/0 (for toggles)
        if (existingValue !== undefined && existingValue !== null && existingValue !== '') {
          merged[key] = existingValue;
        }
      });

      return merged;
    };

    return {
      ...newSettings,
      justificationInfo: mergeSection(existingSettings.justificationInfo, newSettings.justificationInfo),
      decisionInfo: mergeSection(existingSettings.decisionInfo, newSettings.decisionInfo),
      staffInfo: mergeSection(existingSettings.staffInfo, newSettings.staffInfo),
      positionInfo: mergeSection(existingSettings.positionInfo, newSettings.positionInfo),
    };
  };

  // Fetch proposal type
  useEffect(() => {
    const fetchProposalTypes = async () => {
      try {
        const resProposalType = await pdcMeetingApi.getListProposalType();
        if (resProposalType.status === 200) {
          const tempData = resProposalType?.data?.result;
          setInitProposalOptions(
            !isEmpty(tempData)
              ? tempData.map((item) => ({
                  label: <span>{item.category}</span>,
                  title: item.category,
                  options: !isEmpty(item.proposal_types)
                    ? item.proposal_types.map((option) => ({
                        label: <span>{option.name}</span>,
                        value: option.name,
                      }))
                    : [],
                }))
              : [],
          );
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchProposalTypes();
  }, []);

  useEffect(() => {
    if (!proposalType || isOpenSettingHasType) return;

    const fetchProposalItemList = async () => {
      try {
        setLoading(true);
        const res = await pdcMeetingApi.getProposalItemList(proposalType);
        if (res.status === 200) {
          const arr = [{ label: SELECT_ALL_LABEL, value: PROPOSAL_LABEL.SELECT_ALL, checked: false }, ...flattenProposalItems(res.data?.result)];

          if (CONTRACT_TALENTS_SALARY_GRADE.some((salaryGrade) => (currentOpenSettingProposal?.sg || itemExpand?.sg)?.includes(salaryGrade))) {
            setTalentItemList(
              (arr.some((item) => item.value === PROPOSAL_LABEL.STAFF_DETAILS_CONTRACT_END_DATE)
                ? arr
                : [...arr, { label: 'Contract End Date', value: PROPOSAL_LABEL.STAFF_DETAILS_CONTRACT_END_DATE, checked: true }]
              )
                .map((item) => {
                  if (item.value === PROPOSAL_LABEL.RETIREMENT_DATE) {
                    return { ...item, checked: false };
                  }
                  return item;
                })
                .filter((i) => i.checked)
                .map(({ ...m }) => m),
            );
          } else {
            setTalentItemList(arr.filter((i) => i.checked).map(({ ...m }) => m));
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProposalItemList();
  }, [proposalType, isOpenSettingHasType]);

  return (
    <>
      <div style={{ marginBottom: '15px' }}>
        <BreadCrumb level={7} breadCrumbList={BREAD_CRUMB} />
      </div>
      <GlobalAlertMessage style={{ marginBottom: '20px' }} />
      {isShowTopButtons && (
        <MobilityTopButtonControls
          idMeeting={idMeeting}
          mobilityId={mobilityId}
          mobilityDetails={mobilityDetails}
          fetchMobility={fetchMobilityDetails}
          isAdditionalViewAccess={isAdditionalViewAccess}
          isHRPartners={isHRPartners}
          isChairMainOrCommiteeOrAdvocator={isChairMainOrCommiteeOrAdvocator}
          meetingDetail={meetingDetail}
        />
      )}

      {isShownMobilityTabBar ? (
        <MobilityFinalizeBar mobilityDetails={mobilityDetails} />
      ) : (
        <PdcMobilityProcessBar currentStep={2} mobilityDetails={mobilityDetails} isEnableMobilityTab={isEnableMobilityTab} />
      )}
      <Spin spinning={loading}>
        <div className={styles.proposalWrap}>
          <div className={styles.proposalPositionList}>
            {!isEmpty(proposalList.positions) &&
              proposalList.positions.map((item, index) => (
                <div key={`${item.position_code}.${index}`} className={styles.proposalItem}>
                  <div className={`${styles.proposalItemContent}`}>
                    <div className={styles.infoLeft}>
                      {![item?.position_code, item?.birth_name].includes('VACANT') && (
                        <div className={styles.avatar}>
                          <img src={item.image_url || avatar} alt="" />
                        </div>
                      )}
                      <div className={styles.name} style={{ width: '535px' }}>
                        {![item?.position_code, item?.birth_name].includes('VACANT') ? (
                          <Link to={`/profile/${item?.staff_id}`} target="_blank" className={styles.fieldNameLink}>
                            <div className={styles.fieldName}>
                              {item.birth_name || '-'} ({item?.top_talent_status || '-'}, {item?.age || '-'})
                            </div>
                          </Link>
                        ) : (
                          <div className={styles.fieldNameDiff}>
                            <span>{item.birth_name || '-'}</span>
                          </div>
                        )}
                        <div className={styles.fieldDesc}>
                          {item?.position_name}, {item?.business_unit}
                        </div>
                        <div className={styles.normalText}>
                          {item?.division || '-'} | {item?.opu_name || '-'}
                        </div>
                      </div>
                    </div>
                    <div className={styles.fieldItem}>
                      <span className={styles.greyLabel}>JG</span>
                      <span className={styles.boldValue}>{item?.job_grade || '-'}</span>
                    </div>
                    <div className={styles.fieldItem}>
                      <span className={styles.greyLabel}>SG</span>
                      <span className={styles.boldValue}>{item?.sg || '-'}</span>
                    </div>
                    <div className={styles.fieldItem}>
                      <span className={styles.greyLabel}>Retirement:</span>
                      <span className={styles.boldValue}>{item?.retirement_or_contract || '-'}</span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className={styles.proposalList}>
            {!isEmpty(proposallTalentList) &&
              proposallTalentList.map((item, index) => (
                <div key={`${item.staff_id}.${index}`} className={styles.proposalItem}>
                  <div className={styles.proposalItemHead}>
                    <h3>Talent {index + 1}</h3>
                  </div>
                  <div className={`${styles.proposalItemContent}`}>
                    <div className={styles.infoLeft}>
                      <div className={styles.avatar}>
                        <img src={item.image_url || avatar} alt="" />
                      </div>
                      <div className={styles.name} style={{ width: '535px' }}>
                        <Link to={`/profile/${item?.staff_id}`} target="_blank" className={styles.fieldNameLink}>
                          <div className={styles.fieldName}>
                            {item.birth_name || '-'} ({item?.top_talent_status || '-'}, {item?.age || '-'})
                          </div>
                        </Link>
                        <div className={styles.normalText}>
                          {item?.position_name || '-'}, {item?.business_unit || '-'}
                        </div>
                      </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="44" viewBox="0 0 1 44" fill="none">
                      <path d="M1 4.37113e-08L0.999998 44L-1.9233e-06 44L0 0L1 4.37113e-08Z" fill="#CBD6E2" />
                    </svg>
                    <div className={styles.infoCenter}>
                      <div className={styles.readiness}>Readiness</div>
                      <div className={styles.readinessValue}>
                        {item?.readiness ? READINESS_VALUE.find((r) => r.id === item.readiness)?.name || item.readiness : '-'}
                      </div>
                    </div>
                    <div className={styles.textArea}>
                      <TextAreaWithCounter maxLength={200} id={item?.id} remarks={item.remarks} placeholder={'Enter remarks'} />
                    </div>
                    {item.proposal_type && (
                      <>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="44" viewBox="0 0 1 44" fill="none">
                          <path d="M1 4.37113e-08L0.999998 44L-1.9233e-06 44L0 0L1 4.37113e-08Z" fill="#CBD6E2" />
                        </svg>
                        <div className={styles.type}>
                          {PROPOSAL_TYPES.OTHER_PROPOSAL === item.proposal_type && item.proposal_type_name
                            ? item.proposal_type_name
                            : item.proposal_type}
                        </div>
                      </>
                    )}
                    <div className={styles.listAction}>
                      {!isOnlyViewAgenda && (
                        <CustomBtn>
                          <ProposalSetting
                            defaultValues={!isEmpty(talentItemList) ? talentItemList : []}
                            initProposalOptions={initProposalOptions}
                            setInitProposalOptions={setInitProposalOptions}
                            selectedOptions={selectedOptions}
                            setSelectedOptions={setSelectedOptions}
                            setProposalType={setProposalType}
                            proposalType={proposalType}
                            currentItem={item}
                            setItemExpand={setItemExpand}
                            setProposalList={setProposalTalentList}
                            fetchTemplateContent={fetchTemplateContent}
                            handleOpenSettingProposal={handleOpenSettingProposal}
                            setIsOpenSettingHasType={setIsOpenSettingHasType}
                            proposalTypeName={proposalTypeName}
                            setProposalTypeName={setProposalTypeName}
                          />
                        </CustomBtn>
                      )}
                      <CustomBtn>
                        {(!itemExpand || itemExpand?.staff_id !== item.staff_id) && (
                          <img src={Arrow_Down_2} alt="" onClick={() => handleExpandCollapseItem(item)} />
                        )}
                        {itemExpand?.staff_id === item.staff_id && <img src={Arrow_Up_2} alt="" onClick={() => setItemExpand(null)} />}
                      </CustomBtn>
                    </div>
                  </div>
                  {isTemplateContentOpen && openStaffId === item.staff_id && (
                    <div key={item.staff_id} className={`${styles.proposalItemDetail} ${handleReturnExpandCollapseClass(itemExpand, item)}`}>
                      <PdcProposalDetail
                        key={item.staff_id}
                        data={item}
                        setProposalList={setProposalTalentList}
                        isOnlyViewAgenda={isOnlyViewAgenda}
                        prevData={getProposalPrevValue(item)}
                      />
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        {isShowBotButtons && (
          <MobilityBotButtonControls
            idMeeting={idMeeting}
            mobilityId={mobilityId}
            isDisabled={false}
            handleSaveAsDraft={handleSaveAsDraft}
            mobilityDetails={mobilityDetails}
            fetchMobility={fetchMobilityDetails}
            handleClickNext={handleClickNext}
            handleClickBack={handleClickBack}
            isOnlyViewAgenda={isOnlyViewAgenda}
            agendaStatus={mobilityDetails?.status}
            isHRPartners={isHRPartners}
            isAdditionalViewAccess={isAdditionalViewAccess}
            isChairMainOrCommiteeOrAdvocator={isChairMainOrCommiteeOrAdvocator}
            meetingDetail={meetingDetail}
          />
        )}
      </Spin>

      <ModelTC
        info={{
          type: 'withoutSaving',
          visible: isShowPopupSaveAgenda,
          setVisible: setIsShowPopupSaveAgenda,
          onClose: handleKeepNavigate,
          handleSubmit: handleSaveBeforeExit,
        }}
      />
    </>
  );
};

export default PdcProposalTalentList;
